module.exports = __webpack_public_path__ + "img/powered-by-swipe-light.4bc82335.svg";